<gs-generic-crud  #genericCrud *ngIf="config" [configuration]="config"/>
<dx-popup
[visible]="moveFromFamilyVisible"
[title]="'entity.product.selectDestinationFamily' | translate | ucfirst"
[showTitle]="true" [showCloseButton]="true"
height="auto" width="360px"
(onHidden)="moveFromFamilyVisible = false;">

<div>
  <dx-lookup
    [dataSource]="productFamilies"
    valueExpr="id" displayExpr="breadcrumb" [searchExpr]="['breadcrumb']"
    [(value)]="selectedFamily"
    fieldTemplate="itemTemplate" itemTemplate="itemTemplate">
    <div *dxTemplate="let item of 'itemTemplate'" class="familyLookupTemplate">
      <div>{{ item?.breadcrumb }}</div>
    </div>
  </dx-lookup>

  <div class="mt-3 text-right">
    <dx-button
      (onClick)="saveMoveFromFamily()" [type]="selectedFamily ? 'default' : 'normal' "
      [icon]="selectedFamily ?  'save' : 'close'"
      [text]="(selectedFamily ?  'common.save' : 'common.close') | translate | ucfirst"
    ></dx-button>
  </div>
</div>

</dx-popup>
